/** Manhattan distance between two grid points */
export function manhattanDistance(
  col1: number,
  row1: number,
  col2: number,
  row2: number
): number {
  return Math.abs(col1 - col2) + Math.abs(row1 - row2);
}

/** Euclidean distance between two grid points */
export function euclideanDistance(
  col1: number,
  row1: number,
  col2: number,
  row2: number
): number {
  const dc = col1 - col2;
  const dr = row1 - row2;
  return Math.sqrt(dc * dc + dr * dr);
}
